import {
  GetPersonaDetailsRequest,
  GetPersonaDetailsResponse,
  SendBlockAndReportCharacterRequest,
  EmptyResponse,
  CheckChatRoomExistenceRequest,
  CopyCharacterRequest,
  CheckChatRoomExistenceResponse,
  PostCharacterLikeRequest,
} from '~/types';
import {
  CreateCharacterRequest,
  CreateCharacterResponse,
  DeleteMyCharacterRequest,
  EditCharacterDetailRequest,
  GetCharacterDetailsRequest,
  GetCharacterDetailsResponse,
  GetCharacterTypeRequest,
  GetCharacterTypeResponse,
  GetPreSignedUrlRequest,
  GetPreSignedUrlResponse,
} from '~/types/characterApi';
import { fetcher } from './config/fetcher';
import http from './config/http';

export const saveCharacterLike = async ({
  character_id,
}: PostCharacterLikeRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/characters/${character_id}/likes`),
  );
};

export const deleteCharacterLike = async ({
  character_id,
}: PostCharacterLikeRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(`/characters/${character_id}/likes`),
  );
};

export const createCharacter = async (request: CreateCharacterRequest) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(request)) {
    formData.append(key, value);
  }
  return fetcher(() =>
    http.post<CreateCharacterResponse>('/characters', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  );
};

export const getCharacterList = async ({
  page,
  page_size,
  search,
  sort_by,
  type,
  like,
  own,
}: GetCharacterTypeRequest) => {
  return fetcher(() =>
    http.get<GetCharacterTypeResponse>('/characters', {
      params: {
        page,
        page_size,
        search,
        sort_by,
        type,
        like,
        own,
      },
    }),
  );
};

export const getCharacterDetails = async ({
  character_id,
}: GetCharacterDetailsRequest) => {
  return fetcher(() =>
    http.get<GetCharacterDetailsResponse>(
      `/characters/${character_id}/personas`,
    ),
  );
};

export const deleteMyCharacter = async ({
  character_id,
}: DeleteMyCharacterRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(`/characters/${character_id}`),
  );
};

// 안쓰는 API
export const getPreSignedUrl = async ({
  file_type,
  generate_type,
}: GetPreSignedUrlRequest) => {
  return fetcher(() =>
    http.get<GetPreSignedUrlResponse>('/characters-pre-signed-url', {
      params: {
        file_type,
        generate_type,
      },
    }),
  );
};

export const editCharacterDetail = async ({
  character_id,
  ...request
}: EditCharacterDetailRequest) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(request)) {
    formData.append(key, value);
  }
  return fetcher(() =>
    http.put<EmptyResponse>(`/characters/${character_id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  );
};

export const sendBlockAndReportCharacter = async ({
  character_id,
  report_message,
}: SendBlockAndReportCharacterRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/characters/${character_id}/reports`, {
      report_message,
    }),
  );
};

export const getPersonaDetails = async ({
  character_id,
}: GetPersonaDetailsRequest) => {
  return fetcher(() =>
    http.get<GetPersonaDetailsResponse>(`/characters/${character_id}/personas`),
  );
};

export const checkChatRoomExistence = async ({
  character_id,
}: CheckChatRoomExistenceRequest) => {
  return fetcher(() =>
    http.get<CheckChatRoomExistenceResponse>(
      `/characters/${character_id}/chatrooms-check`,
    ),
  );
};

export const copyCharacter = async ({ character_id }: CopyCharacterRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/characters/${character_id}/avatar-copies`),
  );
};
